// ============================================================================
// sheep.batches.detail — migrated off the global read
// ============================================================================
// A persisted sheep processing batch is keyed by its route id. Its resource
// owns the batch record and active-sheep directory; generic collaboration
// sidecars retain their existing entity-scoped lifecycle outside this payload.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'sheep.batches.detail',
  obligations: Object.freeze([Object.freeze({id: 'sheep.batch.detail', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
